// removed by extract-text-webpack-plugin
module.exports = {"member-card":"index-module__member-card___1gbUr","memberCard":"index-module__member-card___1gbUr","member-card-small":"index-module__member-card-small___2mXjs","memberCardSmall":"index-module__member-card-small___2mXjs","member-card-body":"index-module__member-card-body___3ZLl7","memberCardBody":"index-module__member-card-body___3ZLl7","avatar":"index-module__avatar___1MZF3","responsive":"index-module__responsive___3DCSo"};


//////////////////
// WEBPACK FOOTER
// ./src/ui/pages/home-V2/members-card/index.module.scss
// module id = 1742
// module chunks = 147